export const musicGenreOptions = [
  ['afrobeat', 'Afrobeat'],
  ['afrobeats', 'Afrobeats'],
  ['albazo', 'Albazo'],
  ['alternative', 'Alternativa'],
  ['bachata', 'Bachata'],
  ['balada', 'Balada'],
  ['banda', 'Banda'],
  ['bluegrass', 'Bluegrass'],
  ['blues', 'Blues'],
  ['bolero', 'Bolero'],
  ['bossa_nova', 'Bossa nova'],
  ['calypso', 'Calipso'],
  ['cachuyapi', 'Cachuyapi'],
  ['chachacha', 'Chachachá'],
  ['clasica', 'Clásica'],
  ['coral', 'Coral'],
  ['corrido', 'Corrido'],
  ['country', 'Country'],
  ['cumbia', 'Cumbia'],
  ['cueca', 'Cueca'],
  ['dancehall', 'Dancehall'],
  ['dembow', 'Dembow'],
  ['disco', 'Disco'],
  ['drill', 'Drill'],
  ['drum_and_bass', 'Drum and bass'],
  ['dub', 'Dub'],
  ['dubstep', 'Dubstep'],
  ['electronica', 'Electrónica'],
  ['experimental', 'Experimental'],
  ['flamenco', 'Flamenco'],
  ['folk', 'Folk'],
  ['freestyle', 'Freestyle'],
  ['funk', 'Funk'],
  ['fusion', 'Fusión'],
  ['gospel', 'Góspel'],
  ['grunge', 'Grunge'],
  ['guaracha', 'Guaracha'],
  ['hardcore', 'Hardcore'],
  ['hip_hop', 'Hip hop'],
  ['house', 'House'],
  ['huayno', 'Huayno'],
  ['indie', 'Indie'],
  ['instrumental', 'Instrumental'],
  ['jazz', 'Jazz'],
  ['kpop', 'K-pop'],
  ['latin_jazz', 'Latin jazz'],
  ['mambo', 'Mambo'],
  ['mariachi', 'Mariachi'],
  ['metal', 'Metal'],
  ['merengue', 'Merengue'],
  ['musica_andina', 'Música andina'],
  ['musica_cristiana', 'Música cristiana'],
  ['musica_popular', 'Música popular'],
  ['musica_tradicional', 'Música tradicional'],
  ['norteno', 'Norteño'],
  ['nueva_cancion', 'Nueva canción'],
  ['opera', 'Ópera'],
  ['pasillo', 'Pasillo'],
  ['pasodoble', 'Pasodoble'],
  ['pop', 'Pop'],
  ['punk', 'Punk'],
  ['ranchera', 'Ranchera'],
  ['rap', 'Rap'],
  ['reggae', 'Reggae'],
  ['reggaeton', 'Reguetón'],
  ['rnb', 'R&B'],
  ['rock', 'Rock'],
  ['rock_and_roll', 'Rock and roll'],
  ['salsa', 'Salsa'],
  ['samba', 'Samba'],
  ['sanjuanito', 'Sanjuanito'],
  ['saya', 'Saya'],
  ['ska', 'Ska'],
  ['soca', 'Soca'],
  ['son', 'Son'],
  ['soul', 'Soul'],
  ['tango', 'Tango'],
  ['techno', 'Techno'],
  ['trap', 'Trap'],
  ['trance', 'Trance'],
  ['vallenato', 'Vallenato'],
  ['world_music', 'Músicas del mundo'],
  ['other', 'Otro'],
] as const;

export type MusicGenre = (typeof musicGenreOptions)[number][0];
export const musicGenres = musicGenreOptions.map(([code]) => code) as [MusicGenre, ...MusicGenre[]];

export function musicGenreLabel(code: string) {
  return musicGenreOptions.find(([value]) => value === code)?.[1] ?? code;
}
